import storage from "../storage";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export default {
  state: () => ({
    modalContainer: false,
    appBottomSheet: false,
    mapViewModal: false,
    deliveryModal: false,
    appBadge: storage.appBadge(),
    orderSuccess: false,
    // Auth (estado vem do BFF, injetado no HTML — a sessão é um cookie)
    appLoading: false,
    appLoadingLabel: "",
    isAuthenticated: !!globalThis.Smart?.auth?.authenticated,
    // Settings
    settings: storage.settings(),
  }),
  getters,
  actions,
  mutations,
};
